// Generic imports
import React from "react"
import styled from "styled-components"

import JadwalComponent from "components/OrderClass/JadwalComponent"

const Styles = styled.div`
  display: flex;
  flex-wrap: wrap;
  overflow-x: auto;
`

export default function ListJadwal({ jadwalGroups, clickedJadwal }) {
  return (
    <Styles>
      {jadwalGroups?.map((jadwalGroup, index) => (
        <div key={index} onClick={() => clickedJadwal && clickedJadwal(index)}>
          <JadwalComponent list={jadwalGroup.jadwals} />
        </div>
      ))}
    </Styles>
  )
}
